export const sizeClassnames = {
  xs: {
    main: ['h-8', 'w-8'],
    notification: ['h-2', 'w-2'],
  },
  sm: {
    main: ['h-10', 'w-10'],
    notification: ['h-2.5', 'w-2.5'],
  },
  md: {
    main: ['h-12', 'w-12'],
    notification: ['h-3', 'w-3'],
  },
  lg: {
    main: ['h-14', 'w-14'],
    notification: ['h-3.5', 'w-3.5'],
  },
  xl: {
    main: ['h-16', 'w-16'],
    notification: ['h-4', 'w-4'],
  },
}

export const shapeClassnames = {
  circle: 'rounded-full',
  box: 'rounded-md',
}
